import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ordersApi } from "components/Apis/orders";

export const fetchDirectPickupOrders = createAsyncThunk(
    'orders/fetchDirectPickupOrders',
    async (filters = {}, { rejectWithValue }) => {
        try {
            const response = await ordersApi.getDirectPickupOrders(filters);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const fetchOrdersWithSeals = createAsyncThunk(
    'orders/fetchOrdersWithSeals',
    async (filters = {}, { rejectWithValue }) => {
        try {
            const response = await ordersApi.getOrdersWithSeals(filters);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const fetchActiveOrders = createAsyncThunk(
    'orders/fetchActiveOrders',
    async (filters = {}, { rejectWithValue }) => {
        try {
            const response = await ordersApi.getActiveOrders(filters);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const fetchOrderById = createAsyncThunk(
    'orders/fetchOrderById',
    async (orderId, { rejectWithValue }) => {
        try {
            const response = await ordersApi.getOrderById(orderId);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const ordersSlice = createSlice({
    name: 'orders',
    initialState: {
        todaysPickupOrders: null,
        loading: false,
        error: null,
        ordersWithSeals: {
            loading: false,
            error: null,
            orders: null
        },
        activeOrders: {
            loading: false,
            error: null,
            orders: null
        },
        orderDetails: {
            loading: false,
            error: null,
            order: null
        }
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDirectPickupOrders.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDirectPickupOrders.fulfilled, (state, action) => {
                state.loading = false;
                state.todaysPickupOrders = action.payload; // Store the list of people
            })
            .addCase(fetchDirectPickupOrders.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store error message
            });
        builder
            .addCase(fetchOrdersWithSeals.pending, (state) => {
                state.ordersWithSeals.loading = true;
                state.ordersWithSeals.error = null;
            })
            .addCase(fetchOrdersWithSeals.fulfilled, (state, action) => {
                state.ordersWithSeals.loading = false;
                state.ordersWithSeals.orders = action.payload; // Store the list of orders with seals
            })
            .addCase(fetchOrdersWithSeals.rejected, (state, action) => {
                state.ordersWithSeals.loading = false;
                state.ordersWithSeals.error = action.payload; // Store error message
            });
        builder
            .addCase(fetchActiveOrders.pending, (state) => {
                state.activeOrders.loading = true;
                state.activeOrders.error = null;
            })
            .addCase(fetchActiveOrders.fulfilled, (state, action) => {
                state.activeOrders.loading = false;
                state.activeOrders.orders = action.payload; // Store the list of orders
            })
            .addCase(fetchActiveOrders.rejected, (state, action) => {
                state.activeOrders.loading = false;
                state.activeOrders.error = action.payload; // Store error message
            });
        builder
            .addCase(fetchOrderById.pending, (state) => {
                state.orderDetails.loading = true;
                state.orderDetails.error = null;
            })
            .addCase(fetchOrderById.fulfilled, (state, action) => {
                state.orderDetails.loading = false;
                state.orderDetails.order = action.payload; // Store the order details
            })
            .addCase(fetchOrderById.rejected, (state, action) => {
                state.orderDetails.loading = false;
                state.orderDetails.error = action.payload; // Store error message
            });
    },
});

export default ordersSlice.reducer;